import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableExistingAccount = loadable(() => import('./ExistingAccount'), {
  fallback: <LoadingScreen />,
});

export default LoadableExistingAccount;
